export default __webpack_public_path__ + "static/media/GreenhouseDemo.f5e4fab1.svg";